import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { PatientContacts } from '~/features/demographics/contacts/PatientContacts';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientContactsRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Contacts" />}>
			<PatientContacts stayId={stayId} />
		</Section>
	);
}
